<template> 
        <img :src="url"
             :alt="fragment.title"
             :title="fragment.title"
             :style="style"
             class="img-fluid e2e-image"/> 
</template>

<script> 
import { resolveUrl } from "../layout-bom";
import {calculateImageStyle} from "../utils";

/**
 * fragment.url = Link (ggf relativ) zum Bild
 * fragment.title = Beschreibung des Bildes
 */
export default {
  name: "fragment-image",
  props: ["fragment"],
  computed: {
    url() {
      const url = this.fragment.url;
      return resolveUrl(url);
    },
    style() {
      return calculateImageStyle(this.fragment);
    }
  }
};

</script>
 

<style scoped>
</style>